'use strict';
const angular = require('angular');

/*@ngInject*/
export function SubService($resource) {
  return $resource('/api/subs/:id', {
    id: '@_id'
  },{
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    activate: {
      method: 'POST',
      url: '/api/subs/:id/activate'
    },
    deactivate: {
      method: 'POST',
      url: '/api/subs/:id/deactivate'
    }
  });
}


export default angular.module('conduu.SubService', [])
  .factory('SubService', SubService)
  .name;



// WEBPACK FOOTER //
// ./client/services/sub/sub.service.js